import React from 'react'
import Card from '../../components/card'
import { withRouter } from 'react-router-dom'

import { AuthContext } from '../../main/authProvider'
import TransactionService from '../../app/service/estoque/transactionService'
import GeneralServices from '../../app/service/generalServices'
import TransactionByNFTable from './transactionByNFTable'
import ProgressService from '../../app/service/progressService'
import NFService from '../../app/service/estoque/NFService'
import DateIntervalCalendar from '../../components/calendar/dateIntervalCalendar'
import ConstantsUtil from '../../context/constantsUtil'
import { Button } from 'primereact/button'
import ConfiguracaoEmpresaService from '../../app/service/configuracaoEmpresaService'
import HandleErrorService from '../../app/service/handleErrorService'
import AuthService from '../../app/service/authService'

class ValidacaoNFsEntrada extends React.Component {

    constructor(){
        super();
        this.generalServices = new GeneralServices();
        this.progressService = new ProgressService();
        this.transactionService = new TransactionService();
        this.NFService = new NFService();
        this.configuracaoEmpresaService = new ConfiguracaoEmpresaService();
        this.tableRef = React.createRef()
    }

    state = {
        selectedDateFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,
        initialDate: '',
        initialDateView: '',
        finalDate: '',
        finalDateView: '',
        
        habilitaBusca: true,
    }

    componentDidMount(){
        this.checaConfigucarao()
        this.autoSearch()
    }

    isTelaPreValidacao = () => {
        return (window.location.pathname === ConstantsUtil.preValidacaoNFsEntrada)
    }

    checaConfigucarao = () => {
        if(this.isTelaPreValidacao()){
        this.configuracaoEmpresaService.search()
        .then(response => {
            let configuracaoEmpresa = response.data
            if(!configuracaoEmpresa.possuiPreValidacaoNFsEntrada){
                window.location.href = ConstantsUtil.homePathname
            }
            // console.log("completaLogin: ", user)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        }
    }

    autoSearch = async () => {
        await this.generalServices.sleep(100)
        this.search()
    }

    handleDateFilterChange = (selectedDateFilterType) => {
        this.setState({selectedDateFilterType})
    }

    handleDateChange = async (initialDate, finalDate) => {
        await this.setState({initialDate})
        // console.log("handleDateChange initial: ", this.state.initialDate)
        
        await this.setState({initialDateView: GeneralServices.convertBrStringToJsDate(initialDate)})
        // console.log("handleDateChange initialView: ", this.state.initialDateView)

        await this.setState({finalDate})
        await this.setState({finalDateView: GeneralServices.convertBrStringToJsDate(finalDate)})

    }    

    getDataInicial = () => {
        
        let dataInicial = new Date()
        dataInicial.setDate(dataInicial.getDate() - 7)
        return dataInicial;

    }

    getDataFinal = () => {
        
        let dataInicial = new Date()
        // dataInicial.setDate(dataInicial.getDate() - 3)
        return dataInicial;

    }

    search = () => {
        this.setState({habilitaBusca: false})
    }

    getLabel(){

        let label = "Validação das NFs de Entrada"

        switch(window.location.pathname){
            
            case ConstantsUtil.preValidacaoNFsEntrada:
                return `Pré-${label}`
                
            case ConstantsUtil.validacaoNFsEntrada:
                return label

        }
    }

    formattedNFsToExportToExcel = () => {
        let formattedListToExport = []
        let nfsList = this.tableRef.current.getList()
        nfsList.forEach(nf => {
            let row =
            {
                ["Data de Emissão"]: nf.dEmiSemHorario.replaceAll("-", "/"),
                ["Data de Importação"]: nf.dataHoraImportacaoSemHorario.replaceAll("-", "/"),
                ["Número"]: nf.numero,
                ["Fornecedor"]: nf.nomeFornecedorOuCliente,
                ["Valor Total"]: nf.valorTotal,
                ["Tipo"]: nf.tipo,
                ["Chave"]: nf.chave,

            }
            formattedListToExport.push(row)
        })
        return formattedListToExport
    }    

    exportExcel = () => {

        AuthService.startBlockUi()

        let formattedList = this.formattedNFsToExportToExcel()
        let worksheet = GeneralServices.jsonToSheet(formattedList);
        
        const sheetName = "Notas Fiscais"
        
        let workbook = { Sheets: { [sheetName]: worksheet }, SheetNames: [[sheetName]] };

        let filename = `Notas Fiscais pendentes de ${this.isTelaPreValidacao() ? "pre-" : ""}validacao - ${AuthService.getEmpresa()}`
        GeneralServices.saveAsExcelFile(workbook, filename);

        AuthService.stopBlockUi()

    }    

    render() {

        // const renderButtons = () => {
        //     if(this.state.habilitaBusca){
        //         return (
        //             <Button
        //                 label="Buscar"
        //                 icon="pi pi-search"
        //                 className='small-button'
        //                 onClick = {this.search}
        //             />
        //         )
        //     }
        //     return (
        //         <>
        //             <Button 
        //                 label="Voltar"
        //                 icon="pi pi-undo"
        //                 className="p-button-danger small-button"
        //                 onClick = {() => {
        //                     this.setState({filterNFTableState: {}})
        //                     this.setState({habilitaBusca: true})
        //                 }}
        //             />
        //         </>
        //     )            
        // }

        const renderTable = () => {
            if(!this.state.habilitaBusca){
                return (
                    <TransactionByNFTable
                        ref={this.tableRef}
                        validateNFs
                        // dataInicial={this.state.initialDate}
                        // dataFinal={this.state.finalDate}
                    />
                )
            }
        }

        return (
                   
            <div className="bs-docs-section" >
                
                <Card title = {this.getLabel()}>
                    <Button
                        label="Exportar"
                        icon="pi pi-file-excel"
                        className="p-button-success small-button"
                        onClick={this.exportExcel}
                        tooltip={ConstantsUtil.exportXlsxLabel}
                        style ={{marginBottom: '5px'}}
                        // tooltipOptions={{position: 'top'}}
                    />
                    {renderTable()}

                </Card>
                <div className="d-flex "/>
            </div>
              
        )
    }


}

ValidacaoNFsEntrada.contextType = AuthContext

export default withRouter(ValidacaoNFsEntrada)